var exports = {
  "w": "x234b8571--2ce5af--promo-icon",
  "X": "x234b8571--2ce5af--promo-link",
};

module.exports = exports;
